/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Done_HInputs */

const en_funnel_done_h = /** @type {(inputs: Funnel_Done_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're all set.`)
};

const es_funnel_done_h = /** @type {(inputs: Funnel_Done_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo listo.`)
};

/**
* | output |
* | --- |
* | "You're all set." |
*
* @param {Funnel_Done_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_done_h = /** @type {((inputs?: Funnel_Done_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Done_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_done_h(inputs)
	return en_funnel_done_h(inputs)
});